import { Component, Event, EventEmitter, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-password-input',
  styleUrl: 'lab-ds-password-input.css',
  shadow: true,
})
export class LabDsPasswordInput {
  @State() visiblePassword: boolean = false;

  @Prop() value!: string;

  @Prop() titleInput: string = '';

  @Prop() label: string = '';

  @Prop() disabled: boolean = false;

  @Prop() helperText: string = '';

  @Prop() state: 'error' | 'success' | 'default' = 'default';

  @Event() changeInput: EventEmitter<string>;

  handleChange(event) {
    this.changeInput.emit(event.target.value);
  }

  inputPassword = {
    password: {
      icon: 'visibility_off',
    },
    text: {
      icon: 'visibility',
    },
  };

  render() {
    const iconHelper = {
      error: { icon: 'error' },
      success: { icon: 'check_circle' },
      default: { icon: '' },
    };

    const inputType = this.visiblePassword ? 'text' : 'password';

    return (
      <div class={`v4-input ${this.state} ${this.disabled && 'disabled'}`}>
        <span class="title-text">{this.titleInput}</span>
        <div class="input-helper">
          <div class="input-icon">
            <lab-ds-icon-not-selectable class="icon left" size="small" icon="lock" />
            <input disabled={this.disabled} placeholder={this.label} class="input-field" type={inputType} value={this.value} onInput={event => this.handleChange(event)} />
            <lab-ds-icon-not-selectable
              onClick={() => {
                if (this.disabled) return;
                this.visiblePassword = !this.visiblePassword;
              }}
              class="icon right"
              size="small"
              icon={this.inputPassword[inputType].icon}
            />
          </div>
          {this.helperText && (
            <span class="helper-text">
              {iconHelper[this.state].icon && <lab-ds-icon-not-selectable class="icon" size="x-small" icon={iconHelper[this.state].icon} />}
              {this.helperText}
            </span>
          )}
        </div>
      </div>
    );
  }
}
